// extracted by mini-css-extract-plugin
export default {"errorPage":"NotFound_errorPage__06+Us","error_container":"NotFound_error_container__8tis-","zoom_area":"NotFound_zoom_area__kFB+e","link_container":"NotFound_link_container__4jjgF"};